import Eyebrow from "@/components/zeblan/Eyebrow";
import Reveal from "@/components/zeblan/Reveal";

const items = [
  { t: "Dedicated account management", b: "Direct access to the account manager who knows your project inside out. No generic support tickets, just human communication." },
  { t: "Proactive monitoring", b: "We watch your local hosting and agent performance, optimizing processes before you even notice a slowdown." },
  { t: "Continuous optimization", b: "Regular check-ins and minor tweaks keep the AI perfectly aligned with your workflows as new needs emerge." },
  { t: "Security & updates", b: "We handle backend updates, security patching, and server maintenance, without your IT team lifting a finger." },
];

export default function Aftercare() {
  return (
    <section className="bg-navy text-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow tone="teal">Aftercare</Eyebrow>
          <h2 className="mt-6 font-extrabold tracking-tightish" style={{ fontSize: "clamp(28px,3.6vw,40px)" }}>
            We don't launch a complex system and{" "}
            <span className="font-display italic font-medium text-teal">leave you to figure it out</span>
          </h2>
          <p className="mt-6 text-mist/80 text-[16px] leading-relaxed max-w-md">
            AI is dynamic. As your business scales, your tools should evolve with it, so your investment keeps
            generating a high return long after rollout.
          </p>
        </Reveal>

        <Reveal delay={120} className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-6">
            {items.map((it, i) => (
              <div key={it.t} className="pt-6 border-t border-teal/40">
                <h3 className="text-teal text-[16px] font-bold">{it.t}</h3>
                <p className="mt-3 text-mist/80 text-[15px] leading-relaxed">{it.b}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
